import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { JsonListContainerStronaCmsListaDto } from '../modele/json-list-container-strona-cms-lista-dto';
import { JsonObjectContainerStronaCmsSzczegolyOpenDto } from '../modele/json-object-container-strona-cms-szczegoly-open-dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ControllerStronyCmsOpenService {

  private basePHAPIUrl = environment.basePHAPIUrl;

  private listaCache = new Map<string, Observable<JsonListContainerStronaCmsListaDto>>();

  private stronaCache = new Map<string, Observable<JsonObjectContainerStronaCmsSzczegolyOpenDto>>();

  constructor(private http: HttpClient) { }

  getStronyCms(lang: string): Observable<JsonListContainerStronaCmsListaDto> {

    if (!this.listaCache.has(lang)) {
      const request$ = this.http
        .get<JsonListContainerStronaCmsListaDto>(
          `${this.basePHAPIUrl}/stopka/findAll/${lang}`
        )
        .pipe(shareReplay(1));

      this.listaCache.set(lang, request$);
    }

    return this.listaCache.get(lang)!;
  }

  getStronaCmsPoSciezce(
    lang: string,
    sciezka: string
  ): Observable<JsonObjectContainerStronaCmsSzczegolyOpenDto> {

    const key = `${lang}::${sciezka}`;

    if (this.stronaCache.has(key)) {
      return this.stronaCache.get(key)!;
    }

    const params = new HttpParams({
      fromObject: { sciezka }
    });

    const request$ = this.http
      .get<JsonObjectContainerStronaCmsSzczegolyOpenDto>(
        `${this.basePHAPIUrl}/stopkacmstlumaczenia/${lang}`,
        { params }
      )
      .pipe(
        shareReplay(1)
      );

    this.stronaCache.set(key, request$);

    return request$;
  }

  private buildKey(lang: string, sciezka: string): string {
    return `${lang}::${sciezka}`;
  }

  clearCache(): void {
    this.listaCache.clear();
    this.stronaCache.clear();
  }
}
